<template>
  <entity-list-table
    :title="title"
    :data-service="dataService"
    :headers="headers"
    :create-route-name="createRouteName"
    :edit-route-name="editRouteName"
    :allow-delete="allowDelete"
    :show-status-column="showStatusColumn"
    :filter="filter"
  >
    <template v-slot:item.snoType="{ item }">
      {{ getSnoTypeName(item.snoType) }}
    </template>

    <template v-slot:item.yml="{ item }">
      {{ getFilialYmlFeedLink(item.id, baseUrl) }}
    </template>

    <template #item.connectionDate="{ item }">
      {{ formatConnectionDate(item.connectionDate) }}
    </template>
  </entity-list-table>
</template>

<script>
  import FilialDataService from '@/services/api/FilialDataService'
  import EntityListTable from '@/components/ui/crud/EntityListTable'
  import SnoType from '@/models/enums/SnoType'
  import getFilialYmlFeedLink from '@/util/filial-yml-feed-link'
  import { mapGetters } from 'vuex'

  export default {
    components: { EntityListTable },
    data () {
      return {
        title: 'Филиалы',
        dataService: FilialDataService,
        createRouteName: 'filialCreate',
        editRouteName: 'filialEdit',
        showArchived: true,

        headers: [
          { text: 'ID', value: 'id', align: 'start' },
          { text: 'Название', value: 'name', align: 'start' },

          { text: 'Регион', value: 'region', align: 'start', type: 'relation' },
          // { text: 'Город указанный в адресе', value: 'city', align: 'start' },
          { text: 'Адрес', value: 'address', align: 'start' },
          {
            text: 'Синхр-я с Юпитер',
            value: 'jupiterSync',
            align: 'center',
            type: Boolean,
          },
          {
            text: 'Подключен к FAKT',
            value: 'isConnected',
            align: 'center',
            type: 'boolean-check',
          },
          {
            text: 'Дата подкл-я к FAKT',
            value: 'connectionDate',
            align: 'start',
          },
          // { text: 'YML меню', value: 'yml', align: 'start' },
          /* { text: 'Метро', value: 'metro', align: 'start' },
          { text: 'СНО', value: 'snoType', align: 'start' }, */
          // { text: 'Юрлицо', value: 'organization', align: 'start', type: 'relation' },
          //  { text: 'Работает с колл-центром', value: 'useCallCenter', align: 'center', type: 'boolean-check' },
          //  { text: 'Франшиза', value: 'franchise', align: 'center', type: 'boolean-check' },
          //  { text: 'Самовывоз', value: 'hasPickup', align: 'center', type: 'boolean-check' },
          // { text: 'СетДоставка', value: 'setdelivery', align: 'center', type: 'boolean-check' },
          // { text: 'Сытый слон', value: 'wellFedElephant', align: 'center', type: 'boolean-check' },
          {
            text: 'Архивный',
            value: 'archived',
            align: 'center',
            type: 'boolean-check',
          },
        ],

        allowDelete: false,
        showStatusColumn: true,
      }
    },
    computed: {
      ...mapGetters({
        baseUrl: 'api/getBaseWebApiUrl',
      }),
      filter () {
        return {
          'show-archived': this.showArchived,
        }
      },
    },
    methods: {
      getFilialYmlFeedLink,
      getSnoTypeName (enumValue) {
        return SnoType.getName(enumValue)
      },
      formatConnectionDate (connectionDate) {
        if (!connectionDate) {
          return ''
        }

        return new Date(Date.parse(connectionDate)).toLocaleDateString(
          this.$i18n.locale,
          {
            day: 'numeric',
            month: 'numeric',
            year: 'numeric',
          },
        )
      },
    },
  }
</script>
